class ContactUsManager {
  constructor() {
    this.init();
  }

  init() {
    this.setupFAQ();
  }

  setupFAQ() {
    const faqItems = document.querySelectorAll('.contact-us-main .faq-item');
    if (!faqItems.length) return;

    faqItems.forEach((item, index) => {
      const question = item.querySelector('.question');
      const answer = item.querySelector('.answer');
      if (!question || !answer) return;

      item.setAttribute('expanded', 'false');

      question.addEventListener('click', () => {
        const isExpanded = item.getAttribute('expanded') === 'true';
        item.setAttribute('expanded', isExpanded ? 'false' : 'true');
      });

      const likeBtn = answer.querySelector('.answer__feedback__like');
      const dislikeBtn = answer.querySelector('.answer__feedback__dislike');

      if (likeBtn) {
        likeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.trackFeedback('like', index);
        });
      }

      if (dislikeBtn) {
        dislikeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.trackFeedback('dislike', index);
        });
      }
    });
  }

  trackFeedback(type, index) {
    let feedbackThanks = document.querySelector('.contact-us-main .feedback-thanks');

    if (!feedbackThanks) {
      feedbackThanks = document.createElement('div');
      feedbackThanks.className = 'feedback-thanks';
      feedbackThanks.textContent = 'Thank you for your feedback!';
      const faqBlock = document.querySelector('.contact-us-main .contact-us__faq');
      if (faqBlock) faqBlock.appendChild(feedbackThanks);
    }

    feedbackThanks.classList.add('feedback-thanks-animated');
    setTimeout(() => feedbackThanks.classList.remove('feedback-thanks-animated'), 3000);

    const faqItems = document.querySelectorAll('.contact-us-main .faq-item');
    if (faqItems[index]) {
      const feedbackBtn =
        type === 'like'
          ? faqItems[index].querySelector('.answer__feedback__like .mec-icon use')
          : faqItems[index].querySelector('.answer__feedback__dislike .mec-icon use');

      if (feedbackBtn) {
        feedbackBtn.setAttribute('xlink:href', '#mec-yizan');
        const parentBtn = feedbackBtn.closest('div');
        if (parentBtn) {
          parentBtn.style.cursor = 'default';
          parentBtn.style.opacity = '0.7';
        }
      }
    }

    if (type === 'dislike') {
      this.showContactModal();
    }
  }

  getConfigValue(key, defaultValue) {
    const element = document.querySelector(`[data-contact-modal-config="${key}"]`);
    return element?.dataset.value || defaultValue;
  }

  getButtonConfig(buttonNumber) {
    return {
      title: this.getConfigValue(`button${buttonNumber}_title`, buttonNumber === 1 ? 'Email Us' : 'Live Chat'),
      description: this.getConfigValue(
        `button${buttonNumber}_desc`,
        buttonNumber === 1 ? 'Get detailed support via email' : 'Chat with support in real-time'
      ),
      icon: this.getConfigValue(`button${buttonNumber}_icon`, ''),
      url: this.getConfigValue(
        `button${buttonNumber}_url`,
        buttonNumber === 1 ? 'mailto:sia@blovohair.com' : '#chatwoot'
      ),
      useChatwoot:
        buttonNumber === 2 &&
        this.getConfigValue('button2_chatwoot', 'true') !== 'false'
    };
  }

  createSvgIcon(symbolId, className) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', className || 'mec-icon');
    svg.setAttribute('aria-hidden', 'true');
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `#${symbolId}`);
    svg.appendChild(use);
    return svg;
  }

  fillIconContainer(container, imageUrl, symbolId) {
    container.innerHTML = '';
    if (imageUrl) {
      const iconImg = document.createElement('img');
      iconImg.src = imageUrl;
      iconImg.alt = '';
      iconImg.style.maxWidth = '24px';
      iconImg.style.maxHeight = '24px';
      container.appendChild(iconImg);
      return;
    }

    container.appendChild(this.createSvgIcon(symbolId, 'mec-icon'));
  }

  showContactModal() {
    let contactModal = document.querySelector('.contact-modal');

    if (!contactModal) {
      contactModal = document.createElement('div');
      contactModal.className = 'contact-modal';

      const modalContent = document.createElement('div');
      modalContent.className = 'contact-modal__content';

      const modalHeader = document.createElement('div');
      modalHeader.className = 'contact-modal__header';

      const modalTitle = document.createElement('h3');
      modalTitle.className = 'contact-modal__title';
      modalTitle.textContent = this.getConfigValue('title', "We're here to help");

      const closeButton = document.createElement('button');
      closeButton.className = 'contact-modal__close';
      closeButton.type = 'button';
      closeButton.textContent = '×';
      closeButton.addEventListener('click', () => this.hideContactModal());

      modalHeader.appendChild(modalTitle);
      modalHeader.appendChild(closeButton);

      const modalBody = document.createElement('div');
      modalBody.className = 'contact-modal__body';

      const modalDescription = document.createElement('p');
      modalDescription.className = 'contact-modal__description';
      modalDescription.textContent = this.getConfigValue('description', 'Please choose your preferred contact method:');

      const contactButtons = document.createElement('div');
      contactButtons.className = 'contact-buttons';

      const button1Config = this.getButtonConfig(1);
      const button2Config = this.getButtonConfig(2);

      const contactButton1 = document.createElement('a');
      contactButton1.className = 'contact-button';
      contactButton1.href = button1Config.url;

      const iconContainer1 = document.createElement('div');
      iconContainer1.className = 'contact-button__icon';
      this.fillIconContainer(iconContainer1, button1Config.icon, 'mec-email');

      const textContainer1 = document.createElement('div');
      textContainer1.className = 'contact-button__text';
      const title1 = document.createElement('div');
      title1.className = 'contact-button__title';
      title1.textContent = button1Config.title;
      const description1 = document.createElement('div');
      description1.className = 'contact-button__description';
      description1.textContent = button1Config.description;
      textContainer1.appendChild(title1);
      textContainer1.appendChild(description1);
      contactButton1.appendChild(iconContainer1);
      contactButton1.appendChild(textContainer1);

      const contactButton2 = document.createElement('button');
      contactButton2.className = 'contact-button';
      contactButton2.type = 'button';

      if (button2Config.useChatwoot) {
        contactButton2.setAttribute('data-action', 'open-chatwoot');
        contactButton2.setAttribute('data-blovo-chatwoot', '');
        contactButton2.setAttribute('data-chat-source', 'contact-modal');
      }

      const iconContainer2 = document.createElement('div');
      iconContainer2.className = 'contact-button__icon';
      this.fillIconContainer(iconContainer2, button2Config.icon, 'mec-livechat');

      const textContainer2 = document.createElement('div');
      textContainer2.className = 'contact-button__text';
      const title2 = document.createElement('div');
      title2.className = 'contact-button__title';
      title2.textContent = button2Config.title;
      const description2 = document.createElement('div');
      description2.className = 'contact-button__description';
      description2.textContent = button2Config.description;
      textContainer2.appendChild(title2);
      textContainer2.appendChild(description2);
      contactButton2.appendChild(iconContainer2);
      contactButton2.appendChild(textContainer2);

      contactButton2.addEventListener('click', () => {
        if (!button2Config.useChatwoot && button2Config.url) {
          window.location.href = button2Config.url;
        }
        this.hideContactModal();
      });

      contactButtons.appendChild(contactButton1);
      contactButtons.appendChild(contactButton2);
      modalBody.appendChild(modalDescription);
      modalBody.appendChild(contactButtons);
      modalContent.appendChild(modalHeader);
      modalContent.appendChild(modalBody);
      contactModal.appendChild(modalContent);

      if (!document.getElementById('contact-modal-styles')) {
        const style = document.createElement('style');
        style.id = 'contact-modal-styles';
        style.textContent = `
          .contact-modal { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; opacity: 0; visibility: hidden; transition: opacity 0.3s ease, visibility 0.3s ease; }
          .contact-modal.active { opacity: 1; visibility: visible; }
          .contact-modal__content { background-color: #fff; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); width: 90%; max-width: 400px; max-height: 80vh; overflow-y: auto; transform: translateY(-20px); transition: transform 0.3s ease; }
          .contact-modal.active .contact-modal__content { transform: translateY(0); }
          .contact-modal__header { display: flex; justify-content: space-between; align-items: center; padding: 20px 20px 16px; border-bottom: 1px solid #f0f0f0; }
          .contact-modal__title { margin: 0; font-size: 18px; font-weight: 600; color: #333; }
          .contact-modal__close { background: none; border: none; font-size: 24px; cursor: pointer; color: #999; padding: 0; width: 24px; height: 24px; }
          .contact-modal__body { padding: 20px; }
          .contact-modal__description { margin-bottom: 20px; color: #666; font-size: 14px; line-height: 1.4; }
          .contact-buttons { display: flex; flex-direction: column; gap: 12px; }
          .contact-button { display: flex; align-items: center; gap: 12px; padding: 16px; background-color: #fafafa; border: 1px solid #e5e5e5; border-radius: 6px; text-decoration: none; color: inherit; transition: all 0.2s ease; cursor: pointer; width: 100%; text-align: left; font: inherit; }
          .contact-button:hover { background-color: #f0f0f0; border-color: #ccc; transform: translateY(-2px); }
          .contact-button__icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 20px; background-color: #fff; border-radius: 50%; border: 1px solid #e5e5e5; flex-shrink: 0; }
          .contact-button__icon .mec-icon { width: 22px; height: 22px; fill: #6f462e; }
          .contact-button__text { flex: 1; text-align: left; }
          .contact-button__title { font-weight: 500; color: #333; font-size: 16px; margin-bottom: 4px; }
          .contact-button__description { font-size: 14px; color: #666; }
        `;
        document.head.appendChild(style);
      }

      document.body.appendChild(contactModal);

      contactModal.addEventListener('click', (e) => {
        if (e.target === contactModal) this.hideContactModal();
      });

      this._escapeHandler = (e) => {
        if (e.key === 'Escape') this.hideContactModal();
      };
      document.addEventListener('keydown', this._escapeHandler);
    }

    contactModal.classList.add('active');
  }

  hideContactModal() {
    const contactModal = document.querySelector('.contact-modal');
    if (!contactModal) return;
    contactModal.classList.remove('active');
    setTimeout(() => {
      if (contactModal.parentNode) contactModal.parentNode.removeChild(contactModal);
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.contact-us-main')) {
    new ContactUsManager();
  }
});
